module.exports = __webpack_public_path__ + "static/media/loader-without-bgr.8cff97ca.gif";